ixModuleRouting("impactx.passwordrecovery", {
    "/passwordrecovery/:osuTAN": {
        template: "<ixa-password-recovery></ixa-password-recovery>",
        templateUrl: "modules/passwordrecovery/templates/passwordrecovery.html",
        controller: "PasswordRecoveryCtrl",
        controllerAs: "passwordRecoveryCtrl",
        noSecurity: true,
    },
    "/custompasswordrecovery/:hash/:osuTAN": {
        template: "<ixa-custom-password-recovery></ixa-custom-password-recovery>",
        templateUrl:
            "modules/passwordrecovery/templates/custompasswordrecovery.html",
        controller: "CustomPasswordRecoveryCtrl",
        controllerAs: "passwordRecoveryCtrl",
        noSecurity: true,
    },
});
